// extracted by mini-css-extract-plugin
export var closeButton = "_p7-2";
export var closeButtonIcon = "_p7-3";
export var lightboxContent = "_p7-1";
export var lightboxOverlay = "_p7-0";